export default {
  customProduct: {
    CustomProduct: '定制产品',
    Status: '状态',
    SampleFee: '样品费',
    inputPlaceholder: '按产品名称或需求号搜索',
    AddNewDemand: '添加新需求',
    Product: '产品',
    AddedTime: '需求创建时间',
    DemandStatus: '需求接收状态',
    PaymentStatus: '样品费支付状态',
    Action: '行动',
    Details: '详情',
    DemandNo: '产品定制需求流水ID',
    More: '更多',
    Edit: '编辑',
    PaySampleFee: '支付样品费',
    PaymentRecords: '付款记录',
    Cancel: '取消',
    Unreceived: '未接收',
    Received: '已接收',
    Completed: '已完成',
    Canceled: '已取消',
    Published: '已上架',
    Unpaid: '未支付',
    Paid: '已支付',
    CreatedTime: '发起收款时间',
    TransactionTime: '付款时间',
    Amount: '付款金额',
    PaySampleFeeTips: '请支付样品费，样品订单可在付款后生成',
    PaymentAmount: '付款金额',
    PaymentMethod: '付款方式',
    CreditCard: '信用卡',
    Balance: '余额',
    Confirm: '提交',
    transactionError: '生成交易订单异常',
    CustomProcess: '定制流程',
    stepTitle1: '提交您的定制要求',
    stepDescription1_1: '点击',
    stepDescription1_2: '按钮，填写需要定制的产品信息。',
    stepTitle2: '联系我们的客户服务代表',
    stepDescription2: '我们的客户服务代表将向您发送一封联系电子邮件，与您沟通您的定制要求。',
    stepTitle3: '样品的付款和交付',
    stepDescription3: '客户支付打样费，Kakaclo会将样品邮寄给客户确认。',
    stepTitle4: '样品确认和正式生产',
    stepDescription4: '样品确认后，您可以联系我们的客户服务代表开始正式生产。'
  },
  customDetail: {
    Back: '返回',
    AddNewDemand: '增加新需求',
    Style: '风格',
    ProductName: '品名',
    ProductNamePlace: 'T恤、裙子、夹克等',
    ContactEmail: '联系电子邮件',
    ContactEmailPlace: '输入有效的电子邮件号码',
    PhoneNumber: '电话号码',
    EstimatedOrderQuantity: '预计订单数量',
    EstimatedOrderQuantityPlace: '订购的产品数量',
    ColorQuantity: '色量',
    ColorQuantityPlace: '你想定制多少颜色？',
    SizeQuantity: '尺码数量（每种颜色）',
    SizeQuantityPlace: '你想定制多少尺码？',
    ReferenceLinking: '参考链接',
    ReferenceLinkingTooltip: '要自定义的产品的链接。',
    ReferenceLinkingPlace: '输入链接地址',
    Description: '描述',
    DescriptionPlace: '请告诉我们您想定制的产品的详细信息。',
    Image: '形象',
    ImageTip: '（图像最多只能显示10个。）',
    Fabric: '织物',
    Category: '类别',
    FabricName: '织物名称',
    CategoryPlace: '亚麻布、棉布等',
    Weight: '重量（克）',
    WeightPlace: '织物的重量',
    Composition: '作文',
    Add: '添加',
    Accessories: '配件',
    Printing: '印刷',
    PrintingType: '打印类型',
    PrintingTypePlace: '颜料印花等',
    ReferenceLinkingPlace2: '模式的参考链接',
    Width: '宽度(cm)',
    WidthPlace: '图案的宽度',
    Length: '长度(cm)',
    LengthPlace: '图案的长度',
    Position: '位置',
    PositionPlace: '衣服上的印刷位置',
    Description2: '模式的描述',
    Embroidery: '绣花',
    PrintingType2: '贴花、刺绣补丁等',
    Color: '颜色',
    Washing: '洗涤',
    WashingType: '洗涤式',
    WashingTypePlace: '石洗、酶洗等',
    PositionPlace2: '哪个地方需要打扫',
    OtherTechnology: '其他技术',
    TechnologyName: '技术名称',
    Submit: '提交',
    InputContent: '输入内容',
    edit: '编辑',
    detail: '详情',
    onlyPictures: '只能上传图片',
    pictureSize: '最大图像支持为5M，格式支持：jpg、png、gif'
  },
  touristCustom: {
    SubmittedSuccessfully: '提交成功',
    tip1: '感谢您的提交。',
    tip2: '我们的支持团队将跟进并尽快回复您。',
    back: '返回',
    CustomProduct: '定制产品',
    AddedTime: '创建时间',
    DemandNo: '需求号',
    Home: '主页'
  }
}

